import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbNavModule, NgbModalModule, NgbTooltipModule, NgbTypeaheadModule, NgbAlertModule, NgbModule, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { AdvancedtableComponent } from './advancedtable/advancedtable.component';
import { AlertaComponent } from './alerta/alerta.component';
import { CampoComponent } from './campo/campo.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MenuLateralComponent } from './menu-lateral/menu-lateral.component';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { TabsComponent } from './tabs/tabs.component';
import { TabComponent } from './tabs/tab.component';
import { DynamicTabsDirective } from './tabs/dynamic-tabs.directive';
import { CboSelectComponent } from './cbo-select/cbo-select.component';
import { NavComponent } from './tabs/nav.component';
import { NavsComponent } from './tabs/navs.component';
import { DynamicNavsDirective } from './tabs/dynamic-navs.directive';
import { SimpleMsComponent } from './simple-ms/simple-ms.component';
import { WizardComponent } from '../../pages/wizard/wizard.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EmailComponent } from './email/email.component';
import { EmailDetailsComponent } from './email-details/email-details.component';
// ArchivosComponent: movido a UiHeavyModule (lazy).
// import { ArchivosComponent } from './archivos/archivos.component';
import { ScrollToTopComponent } from './scroll-to-top/scroll-to-top.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { UiSwitchModule } from 'ngx-ui-switch';
import { UploadComponent } from './upload/upload.component';
import { ReportesComponent } from './reportes/reportes.component';
import { FiltrocampoComponent } from './filtrocampo/filtrocampo.component';
import { FiltrocampoInlineComponent } from './filtrocampo-inline/filtrocampo-inline.component';
import { ModalCustomComponent } from './modal-custom/modal-custom.component';
import { EchartComponent } from './echart/echart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { ServicioEstudianteComponent } from './servicio-estudiante/servicio-estudiante.component';
import { CalendarioInstitucionalComponent } from './servicio-estudiante/calendario-institucional/calendario-institucional.component';
import { CuentasPendientesComponent } from './servicio-estudiante/cuentas-pendientes/cuentas-pendientes.component';
import { MatriculaComponent } from './servicio-estudiante/matricula/matricula.component';
import { OfertaAcademicaComponent } from './servicio-estudiante/oferta-academica/oferta-academica.component';
import { PeriodoActualComponent } from './servicio-estudiante/periodo-actual/periodo-actual.component';
import { PlanEstudiosComponent } from './servicio-estudiante/plan-estudios/plan-estudios.component';
import { RecordHistoricoComponent } from './servicio-estudiante/record-historico/record-historico.component';
import { RecursosComponent } from './servicio-estudiante/recursos/recursos.component';
import { ServiciosEstudiantilesComponent } from './servicio-estudiante/servicios-estudiantiles/servicios-estudiantiles.component';
import { TramitesEstudiantilesComponent } from './servicio-estudiante/tramites-estudiantiles/tramites-estudiantiles.component';
import { DetalleComponent } from '../../pages/mantenimientos/detalle.component';
import { AusenciasComponent } from './serviciodocente/ausencias/ausencias.component';
import { NotasComponent } from './serviciodocente/notas/notas';
import { MarcajesQuincenaComponent } from './rhu/marcajes-quincena/marcajes-quincena.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DocumentosComponent } from './documentos/documentos.component';
import { DropzoneComponent } from './dropzone/dropzone.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { FiltrocanvasComponent } from './filtrocanvas/filtrocanvas.component';
import { SidebarAvatarComponent } from './sidebar/sidebar.component';
import { FlexmonsterComponent } from './flexmonster/flexmonster.component';
import { LazyHeavyComponent } from '../ui-heavy/lazy-heavy.component';
import { AdvancetableEditableComponent } from './advancetable-editable/advancetable-editable.component';
// FileManagerModule + services + ArchivosComponent: movidos a UiHeavyModule (lazy).
// import { FileManagerModule, NavigationPaneService, ToolbarService, DetailsViewService } from '@syncfusion/ej2-angular-filemanager';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
// PivotViewModule + PivotFieldListAllModule + FieldListService: movidos a UiHeavyModule (lazy, lo usa Flexmonster via <app-lazy-heavy type="pivot">).
// import { PivotViewModule, PivotFieldListAllModule } from '@syncfusion/ej2-angular-pivotview';

// GanttComponent + GanttModule + services: movidos a UiHeavyModule (lazy).
// import { GanttComponent } from './gantt/gantt.component';
// import { ExcelExportService, GanttModule, PdfExportService, RowDDService } from '@syncfusion/ej2-angular-gantt';
// import { EditService, SelectionService } from '@syncfusion/ej2-angular-gantt';

import { DashboardComponent } from './dashboard/dashboard.component';
import { SliderComponent } from './slider/slider.component';
import { PerfilPersonalComponent } from './perfil-personal/perfil-personal.component';
import { PanelAccionesComponent } from './panel-acciones/panel-acciones.component';
import { PanelEventosComponent } from './panel-eventos/panel-eventos.component';
import { PanelIndicadoresComponent } from './panel-indicadores/panel-indicadores.component';
import { PanelListadoComponent } from './panel-listado/panel-listado.component';
import { PanelFiltrosComponent } from './panel-filtros/panel-filtros.component';
// import { ResizeService, ReorderService, DayMarkersService } from '@syncfusion/ej2-angular-gantt';   // (movidos a UiHeavyModule)
import { PanelReportesComponent } from './panel-reportes/panel-reportes.component';
import { ListaEditableSyncComponent } from './lista-editable-sync/lista-editable-sync.component';
import { ListaCardsComponent } from './lista-cards/lista-cards.component';
import { StepperComponent } from './stepper/stepper.component';

// CalendarioComponent + ScheduleModule + Schedule services: movidos a UiHeavyModule (lazy).
// import { CalendarioComponent } from './calendario/calendario.component';
// import { AgendaService, DayService, MonthAgendaService, MonthService, ScheduleModule, TimelineMonthService, TimelineViewsService, WeekService, WorkWeekService } from '@syncfusion/ej2-angular-schedule';

// CheckBoxModule: movido a UiHeavyModule (lo usa CalendarioComponent).
//import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';

import { GridModule } from '@syncfusion/ej2-angular-grids';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs'
import { AccordionModule, StepperAllModule } from '@syncfusion/ej2-angular-navigations';
import { SliderSfComponent } from './slider-sf/slider-sf.component';
import { RatingModule, SliderModule } from '@syncfusion/ej2-angular-inputs';
import { StarRatingComponent } from './star-rating/star-rating.component';

import { SidebarModule } from '@syncfusion/ej2-angular-navigations';
import { CheckoutComponent } from './checkout/checkout.component';
import { RespuestaPagoEcommerceComponent } from './respuesta-pago-ecommerce/respuesta-pago-ecommerce.component';
import { CambioContrasenaComponent } from './cambio-contrasena/cambio-contrasena.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ExtensionSlotComponent } from '../extensions/extension-slot.component';
import { FacDesglosePagoComponent } from '../extensions/fac-desglose-pago/fac-desglose-pago.component';
import { BoardComponent as ProBoardComponent } from './pro/board/board';
import { MapeoRegistrosComponent } from './mapeo-registros/mapeo-registros.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { HorariosComponent } from './horarios/horarios.component';

@NgModule({
  declarations: [
    PagetitleComponent, AdvancedtableComponent, CampoComponent, WizardComponent, MenuLateralComponent, ReportViewerComponent,
    TabComponent, TabsComponent, DynamicTabsDirective, CboSelectComponent, NavsComponent, NavComponent, DynamicNavsDirective,
    SimpleMsComponent, EmailComponent, EmailDetailsComponent,  ScrollToTopComponent, 
    UploadComponent, ReportesComponent, FiltrocampoComponent, FiltrocampoInlineComponent, NotasComponent, AusenciasComponent,
    ModalCustomComponent, EchartComponent, ServicioEstudianteComponent, CalendarioInstitucionalComponent, CuentasPendientesComponent,
    MatriculaComponent, OfertaAcademicaComponent, PeriodoActualComponent, PlanEstudiosComponent, RecordHistoricoComponent,
    RecursosComponent, ServiciosEstudiantilesComponent, TramitesEstudiantilesComponent, DetalleComponent, DocumentosComponent,
    DropzoneComponent, SidebarAvatarComponent, FiltrocanvasComponent, FlexmonsterComponent, LazyHeavyComponent, AdvancetableEditableComponent, 
	DashboardComponent, SliderComponent, PerfilPersonalComponent, PanelAccionesComponent, PanelEventosComponent, 
	PanelIndicadoresComponent, PanelListadoComponent, PanelFiltrosComponent, 
	AlertaComponent, ListaEditableSyncComponent, ListaCardsComponent, StepperComponent, SliderSfComponent, StarRatingComponent,
	PanelReportesComponent, CheckoutComponent, RespuestaPagoEcommerceComponent, CambioContrasenaComponent, MarcajesQuincenaComponent,
	FacDesglosePagoComponent, ProBoardComponent, ExtensionSlotComponent, MapeoRegistrosComponent, HorariosComponent
  ],
  imports: [
    SharedComponentsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbNavModule,
    NgbModalModule,
    NgbTooltipModule,
    NgxPaginationModule,
    NgbAlertModule,
    NgbModule,
    NgSelectModule,
    UiSwitchModule,
    NgxEchartsModule,
    CKEditorModule,
    NgxDropzoneModule,
    CodemirrorModule,
    FullCalendarModule,
    // FileManagerModule: movido a UiHeavyModule (lazy).
    NgxMaskDirective, 
    NgxMaskPipe,
    NgbAccordionModule,
    // PivotViewModule + PivotFieldListAllModule: movidos a UiHeavyModule (lazy).
    // GanttModule: movido a UiHeavyModule (lazy).
    // ScheduleModule + CheckBoxModule: movidos a UiHeavyModule (lazy).
    GridModule,
    TextBoxModule,
    StepperAllModule,
    SliderModule,
    RatingModule,
    SidebarModule,
    QRCodeModule,
    DragDropModule
  ],
  exports: [
    PagetitleComponent, AdvancedtableComponent, CampoComponent, WizardComponent, EchartComponent,
    MenuLateralComponent, TabComponent, TabsComponent, CboSelectComponent, UploadComponent,
    NavsComponent, NavComponent, EmailComponent, EmailDetailsComponent, DetalleComponent, AdvancetableEditableComponent,
	AlertaComponent, ExtensionSlotComponent, HorariosComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [provideNgxMask(),
              // FileManager services (NavigationPaneService, ToolbarService, DetailsViewService): movidos a UiHeavyModule.
              // Gantt services (EditService, SelectionService, ExcelExportService, PdfExportService,
              //   RowDDService, ResizeService, ReorderService, DayMarkersService): movidos a UiHeavyModule.
              // Schedule services (DayService, WeekService, WorkWeekService, MonthService, AgendaService,
              //   MonthAgendaService, TimelineViewsService, TimelineMonthService): movidos a UiHeavyModule.
             ]
})
export class UIModule { }


